<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-05 15:43:20
-->
<template>
  <div>
    <!-- -->
    <mrc_ess_table
      v-if="$route.name == 'timedTask'"
      :headers="headers"
      :hideAddBtn="!hasBtn('add-scheduled-job')"
      pageName="addTimedTask"
      :paginationOptions="options"
      @turnPage="getlist"
      :isLoading="loading"
      :slotKey="['job_name', 'status']"
      :items="desserts"
    >
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px"
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template #item.job_name="{item}">
        {{ INT(item.job_name) }}
      </template>
      <!-- 状态 -->

      <template v-slot:item.status="{ item }">
        <mrc_ess_viewbtn :label="item.status" :is_used="item.status_save_value">
        </mrc_ess_viewbtn>
      </template>

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon
              v-btnAuth="[
                'view-scheduled-job',
                'edit-scheduled-job',
                'delete-scheduled-job',
                'scheduled-job-execute-now',
              ]"
              >mdi-dots-vertical</v-icon
            >
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import {
  getTimedTaskList,
  deleteTimedTask,
  executeTimedTask,
} from "@/service/api/timedTask.js"
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      disabled: true,
      list: {},
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
        selectlist: [10, 20, 50, 100, 200],
        pagetext: this.$t("label_Each_page_shows"),
      },
      loading: false,
      desserts: [],
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_The_name_of_the_task"),
          align: "start",
          value: "job_name",
          sortable: false,
        },
        {
          text: this.$t("label_grouping"),
          value: "job_group",
          sortable: false,
        },
        {
          text: this.$t("label_Call_target_string"),
          value: "invoke_target",
          sortable: false,
        },
        {
          text: this.$t("label_Execution_expression"),
          value: "cron_expression",
          sortable: false,
        },
        { text: this.$t("label_state"), value: "status", sortable: false },
        { text: "", value: "actions", sortable: false, align: "end" },
      ]
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          type: "view",
          show: this.hasBtn("view-scheduled-job"),
        },
        {
          name: this.$t("label_Edit"),
          type: "edit",
          show: this.hasBtn("edit-scheduled-job"),
        },
        {
          name: this.$t("label_Executed_immediately"),
          type: "immediately",
          show: this.hasBtn("scheduled-job-execute-now"),
        },
        {
          name: this.$t("label_delete"),
          type: "del",
          show: this.hasBtn("delete-schedule-job"),
        },
      ]
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  beforeDestroy() {},
  async created() {
    await this.getBtnPermissionList()
  },
  watch: {
    $route(v) {
      if (v.name == "timedTask") {
        this.getlist()
      }
    },
  },
  mounted() {
    // console.log(this.$route);
    // getTimedTaskList()
    this.getlist()
  },

  methods: {
    async getlist(obj) {
      this.loading = true
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj
        this.options = { ...this.options, ...obj }
      }
      const res = await getTimedTaskList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.options.totalcount = res.totalcount
        this.options.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    addemailtemplate() {
      this.$store.commit("set_subPage_name", "")
      this.$store.commit("set_uuid", "")
      this.$store.commit("set_iconstatus", "") //行内进图标显示
      this.$router.push({
        name: "addemailtemplate",
      })
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true) //行内进图标显示
      this.$store.commit("set_subPage_name", item.job_name)
      this.$store.commit("set_uuid", item.uuid) //
      this.$router.push({
        name: "detailTimedTask",
      })
    },
    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj)
          break
        case "edit":
          this.$store.commit("set_subPage_name", obj.job_name)
          this.$store.commit("set_iconstatus", false) //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid) //
          this.$router.push({
            name: "detailTimedTask",
          })
          break
        case "immediately":
          this.$myConfirm({
            content: this.$t(
              "message_Confirm_that_you_want_to_perform_the_timed_task_immediately"
            ),
          })
            .then((res) => {
              executeTimedTask({ uuid: obj.uuid }).then((res) => {
                if (res.code == 200) {
                  this.$Message({
                    text: this.$t("message_The_operation_was_successful"),
                  })
                }
              })
            })
            .catch((err) => {})
          break
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            deleteTimedTask({ uuid: obj.uuid }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                })
                if (this.desserts.length == 1) this.options.cpage--
                this.getlist()
              }
            })
          })
          break
      }
    },
  },
}
</script>

<style scoped>
.cardtitle {
  position: relative;
}
.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}
</style>
